<iw-details-value
  label="withdrawal.advcash.walletAddress.label"
  [value]="details.walletAddress"
/>
